import { FDealType } from '@/packages/JsonQuery';

import { type IContractTypeOption } from '../types';

import { RENT_CONTRACT_TYPE_OPTIONS, SALE_CONTRACT_TYPE_OPTIONS } from './constants';

export function getContractTypeList(dealType: FDealType): IContractTypeOption[] {
  return dealType & FDealType.Sale ? SALE_CONTRACT_TYPE_OPTIONS : RENT_CONTRACT_TYPE_OPTIONS;
}
